import { createContext, use } from "react";
import type { ThemeDocument } from "@/api/queries";
import type { ResolvedColorScheme } from "./colorScheme";

export interface ThemeContextValue {
  theme: ThemeDocument | undefined;
  scheme: ResolvedColorScheme;
  /** Product name; empty until the theme resolves. */
  productName: string;
  /** Empty when the name was rebranded and the tagline was not — see ThemeProvider. */
  tagline: string;
  /** The email and export footer, with `{name}`/`{vendor}` substituted. */
  footer: string;
  /** How the agent introduces itself. Never a literal in a component. */
  assistantName: string;
  /** Welcome copy with `{name}`/`{vendor}` already substituted; may be empty,
   *  which means "use the platform's own sentence" rather than "show nothing". */
  welcomeTitle: string;
  welcomeBody: string;
  /** The logo file for the current scheme, or null when none is configured. */
  logo: string | null;
  /** Categorical chart palette for the current scheme. */
  categorical: string[];
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useBrand(): ThemeContextValue {
  const value = use(ThemeContext);
  if (value === null) {
    throw new Error("useBrand must be used inside a ThemeProvider");
  }
  return value;
}
